export default "__VITE_ASSET__CTt4TuQu__"